<script setup lang="ts">
import type { Plan } from "@/lib/types";
import { RadioGroup } from "@/components/ui/radio-group";
import PlanCard from "./PlanCard.vue";

interface Props {
  plans: Plan[];
  selectedPlan: string;
  loading: boolean;
  itemsPerPage: number;
}

defineProps<Props>();

const emit = defineEmits<{
  "update:selectedPlan": [value: string];
}>();
</script>

<template>
  <RadioGroup
    :model-value="selectedPlan"
    @update:model-value="emit('update:selectedPlan', $event)"
    class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6"
  >
    <template v-if="loading">
      <div
        v-for="i in itemsPerPage"
        :key="i"
        class="h-44 border-2 bg-background rounded-xl animate-pulse"
      />
    </template>

    <template v-else>
      <PlanCard
        v-for="plan in plans"
        :key="plan.packageCode"
        :plan="plan"
        :selected="selectedPlan === plan.packageCode"
        @select="emit('update:selectedPlan', $event)"
      />
    </template>
  </RadioGroup>
</template>
